import { efficiencyYBIEntity } from "../../domain/entities/efficiency_ybi_entity";
import { efficiencyYBIFinishedEntity } from "../../domain/entities/efficiency_ybi_finished_entity"
import { buyoutYBIEntity } from "../../domain/entities/buyout_ybi_entity"
import { summaryTransitYBIEntity } from "../../domain/entities/summary_transit_ybi_entity";
import { transitYBIEntity } from "../../domain/entities/transit_ybi_entity";
import { YegoDashboardContract } from "../../domain/contracts/yego_dashboard_contract";
import http from "../../../../plugins/http-common"
// import i18n from "../../../../i18n";

export const HttpYegoDashboardRepository = {
    ...YegoDashboardContract,
    efficiency_model: efficiencyYBIEntity,
    efficiency_finished_model: efficiencyYBIFinishedEntity,
    buyout_model: buyoutYBIEntity,
    summary_model: summaryTransitYBIEntity,
    transit_model: transitYBIEntity,

    // month 0 - 11 (january - december)
    // endpoint should be in format: january -> 1, february -> 2...
    // month - 1:  10(nov) - 1 should be 9 octuber, displaying 9(oct), 10(nov) and 11(dec)  
    async efficiencyYBI(client_id, period, year, month, shipping_service) {
        const res = await http.get('smart-carrier?client_id=' + client_id + '&period=' + period + '&year=' + year + '&initial_month=' + (parseInt(month) - 1) + '&shipping_service=' + shipping_service);
        
        return res;
    },

    async efficiencyYBIFinishied(client_id, period, year, month, shipping_service) {
        const res = await http.get('smart-carrier/alternative?client_id=' + client_id + '&period=' + period + '&year=' + year + '&initial_month=' + (parseInt(month) - 1) + '&shipping_service=' + shipping_service);
        
        return res;
    },

    async buyoutYBI(client_id, period, year, month, shipping_service) {
        const res = await http.get('smart-carrier/buy-out?client_id=' + client_id + '&period=' + period + '&year=' + year + '&initial_month=' + (parseInt(month) - 1) + '&shipping_service=' + shipping_service);

        return res;
    },

    async summaryTransitYBI(year, month, client_id, shipping_service) {
        const res = await http.get('business-intelligence/transit-days/summary?year=' + year + '&month=' + (parseInt(month) + 1) + '&client_id=' + client_id + '&shipping_service=' + shipping_service);

        return res;
    },


    async transitYBI(year, month, client_id, shipping_service) {
        const res = await http.get('business-intelligence/transit-days/by-state?year=' + year + '&month=' + (parseInt(month) + 1) + '&client_id=' + client_id + '&shipping_service=' + shipping_service);

        return res;
    },

    async transitPickupYBI(year, month, client_id, shipping_service) {
        const res = await http.get('business-intelligence/transit-days/by-state/pickup?year=' + year + '&month=' + (parseInt(month) + 1) + '&client_id=' + client_id + '&shipping_service=' + shipping_service);

        return res;
    },
};